import { Center } from '@chakra-ui/react';
import React from 'react';
import SvgIcon from '../SvgIcon';
import svgIcons from '@/assets/svg/icons';

const DefaultAvatar = ({ containerSize = 100 }: { containerSize?: number }) => {
  return (
    <Center
      backgroundColor={'#EDE8FD'}
      height={containerSize}
      width={containerSize}
      borderRadius={'full'}
      shadow={'0px 6px 24px 0px rgba(14, 0, 98, 0.2)'}
      border={'3px solid white'}
    >
      <SvgIcon
        color={'#fff'}
        iconPath={svgIcons.userSeeThrough}
        size={containerSize * 0.6}
        boxHeight={80}
        boxWidth={80}
      />
    </Center>
  );
};

export default DefaultAvatar;
